//SelectionMode.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as Search from "../Search/Search";

import { Checkbox, FormControl, FormControlLabel, FormLabel, FormGroup, Radio } from "@mui/material";

import React from "react";

export let value: string = "New"; //New, Add, or Remove.
export let skipDoneIBM: boolean = false; //Don't select already done ibm reassessment records.

let newSelection: boolean = true; //Radio button values.
let addTo: boolean = false;
let removeFrom: boolean = false;
let removeDisabled: boolean;

interface iProps {
   tool: string;
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of SelectionMode Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Selection mode changed event.
   function selectionModeChanged(event: React.ChangeEvent<HTMLInputElement>): void {
      //let checked: boolean = event.target.checked;
      const value2: string = event.target.defaultValue;
      value = value2;

      newSelection = false;
      addTo = false;
      removeFrom = false;

      if (value2 === "New") {
         newSelection = true;
      } else if (value2 === "Add") {
         addTo = true;
      } else {
         removeFrom = true;
      }
      refresh();
   }

   //Component did mount.
   React.useEffect(() => {
      //Util.logMsg("SelectionMode mounted");
   }, []);

   //Dont select already done reassessment parcels changed.
   function skipDoneIBMChanged(event: any) {
      const checked: boolean = event.target.checked;
      skipDoneIBM = checked;
      refresh();
   }

   removeDisabled = false;
   if (Search.grandTotRec === 0) {
      //SelectionMode.value = "New";
      //newSelection = true;
      //addTo = false;
      //removeFrom = false;
      removeDisabled = true;
   }

   const styles: Default.iStyles = {
      formControlLabel: { height: 40, paddingRight: 14 },
   };

   return (
      <div>
         <FormControl style={{ marginLeft: 5, marginTop: 12 }}>
            <FormLabel htmlFor={ "new-select-" + props.tool }>Selection Mode</FormLabel>

            <FormGroup row={true}>
               <FormControlLabel style={styles.formControlLabel} title="Start new selection"
                  control={<Radio inputProps={{ id: "new-select-" + props.tool }} value="New" checked={newSelection} onChange={selectionModeChanged} />}
                  label="New"
               />
               <FormControlLabel style={styles.formControlLabel} title="Add to existing selection"
                  control={<Radio inputProps={{ id: "add-to-select-" + props.tool }} value="Add" checked={addTo} onChange={selectionModeChanged} />}
                  label="Add"
               />
               <FormControlLabel disabled={removeDisabled} style={styles.formControlLabel} title="Remove from existing selection"
                  control={<Radio inputProps={{ id: "remove-from-select-" + props.tool }} value="Remove" checked={removeFrom} onChange={selectionModeChanged} />}
                  label="Remove"
               />
            </FormGroup>
         </FormControl>

         <FormControlLabel style={{ marginLeft: 1 }} title="Don't select already done parcels"
            control={<Checkbox checked={skipDoneIBM} color="primary" onChange={skipDoneIBMChanged} />}
            label="Don't select already done parcels"
         />
      </div>

   ); //end return.

} //end function.
